import React from 'react';

import styles from './Heading.module.scss';

export interface IHeadingProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title: string;
    subtitle?: string;
}

export const Heading = ({ title, subtitle }: IHeadingProps) => {
    return (
        <div className={styles.headingWrapper}>
            <h1>{title}</h1>
            {subtitle && <h2>{subtitle}</h2>}
        </div>
    );
};
